<script lang="ts" context="module">
    export const name = "Infinite scroll";
</script>

<script lang="ts">
    import { z } from "zod";
    import Data from "@reperio-news/core.components/blocks/ContentList/Data";
    import ContentItem from "@reperio-news/core.components/blocks/ContentItem/View.svelte";
    import Hydrator from "@reperio-news/core.components/Hydrator.svelte";
    import { getContext } from "svelte";
    import Ad from "@reperio-news/core.components/blocks/AdPosition/View.svelte";

    type Data = z.infer<typeof Data>;
    export let data: Data;

    const c: SvelteStore<number | null> = getContext("parentBlockColumnCount");
    const context: SvelteStore<any> = getContext("context");

    const bannerAd = `<div id="M303021ScriptRootC1392333" style="width:calc(100% - 20px); margin: auto;"></div>
    <script type="text/plain" class="optanon-category-C0004" src="https://jsc.mgid.com/h/i/historia.ro.1392333.js" async><\/script>
    `;
</script>

{#if data.content && data.content.items && data.content.items.length}
    {#each data.content.items as item, index}
        <ContentItem
            data={{
                content: item,
                layout: data.content_layout,
                custom_fields: data.content_custom_fields,
            }}
        />

        {#if $context?.type === "content" && index + 1 === $c * 2}
            <Ad
                id="ad-in-infinitescroll"
                globalId={null}
                globalSource={null}
                data={{
                    for_desktop: true,
                    for_mobile: true,
                    html_desktop: bannerAd,
                    html_mobile: bannerAd,
                }}
            />
        {/if}
    {/each}

    {#if !__ADMIN__}
        <Hydrator
            props={{
                already_loaded_ids: data.content.items.map((item) => item.id),
                data: {
                    ...data,
                    content: { ...data.content, items: [] },
                },
            }}
            component="InfiniteScrollBox"
            hydrate={true}
        />
    {/if}
{/if}
